/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamsConnectionUpdate
 */
export interface TeamsConnectionUpdate {
    /**
     * 
     * @type {string}
     * @memberof TeamsConnectionUpdate
     */
    name: string;
}

export function TeamsConnectionUpdateFromJSON(json: any): TeamsConnectionUpdate {
    return TeamsConnectionUpdateFromJSONTyped(json, false);
}

export function TeamsConnectionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsConnectionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function TeamsConnectionUpdateToJSON(value?: TeamsConnectionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


